import React from "react";
import { UnitTableFilters } from "./filter/UnitTableFilters";
import { UnitTableSort } from "./sort/UnitTableSort";
import type { UnitCategory, UnitFeature } from "@/types";

interface UnitTableControlsProps {
    features: UnitFeature[];
    selectedFeatures: number[];
    setSelectedFeatures: React.Dispatch<React.SetStateAction<number[]>>;
    categories: UnitCategory[];
    selectedCategories: number[];
    setSelectedCategories: React.Dispatch<React.SetStateAction<number[]>>;
    selectedSort: string;
    setSelectedSort: React.Dispatch<React.SetStateAction<string>>;
}
export const UnitTableControls = ({
    features,
    selectedFeatures,
    setSelectedFeatures,
    categories,
    selectedCategories,
    setSelectedCategories,
    selectedSort,
    setSelectedSort,
}: UnitTableControlsProps) => {
    return (
        <div className="unit-table-controls tw:flex tw:flex-row tw:space-x-3 tw:items-end">
            <UnitTableFilters
                features={features}
                selectedFeatures={selectedFeatures}
                setSelectedFeatures={setSelectedFeatures}
                categories={categories}
                setSelectedCategories={setSelectedCategories}
                selectedCategories={selectedCategories}
            />
            <UnitTableSort
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
            />
        </div>
    );
};
